import styled from 'styled-components'

import { InsertDriveFileOutlinedIcon, PublicIcon } from '@components/ui/svgIcons'

const IconWrapper = styled.div<{
  $fontSize: 'inherit' | number
  $isLink: boolean
}>`
  font-size: ${({ $fontSize }) => (typeof $fontSize === 'number' ? `${$fontSize}px` : $fontSize)};
  color: ${({ $isLink, theme }) => ($isLink ? theme.colors.common.oceanBlue : theme.colors.primary[50])};

  & > svg {
    transform: translate(0, 2px);
  }
`

interface DocumentTypeProps {
  fontSize?: 'inherit' | number
  isLink: boolean
}

export function DocumentType({ fontSize = 18, isLink }: DocumentTypeProps) {
  const Icon = isLink ? PublicIcon : InsertDriveFileOutlinedIcon
  return (
    <IconWrapper $fontSize={fontSize} $isLink={isLink}>
      <Icon size={20} />
    </IconWrapper>
  )
}
